<template>
  <div>
    Validação
    <v-btn
      depressed
      block
      color="primary"
      @click="$router.push({ name: 'Urna'})"
      :loading="loading"
      :disabled="loading"
    >
      <v-icon>ballot</v-icon>Votar
    </v-btn>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      valid: false,
      voterId: '',
      maxLength: 12,
      loading: false,
      rules: {
        required: value => !!value || 'Campo obrigatório',
        counter: value =>
          (value && value.length === this.maxLength) || 'Deve conter 12 dígitos'
      }
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
